/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Ticket Layout Manager Service
 * OpenAPI spec version: 0.0.1
 */
import { HttpClient } from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse as AngularHttpResponse,
} from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type { UserDto } from '.././model';

interface HttpClientOptions {
  headers?: HttpHeaders | Record<string, string | string[]>;
  context?: HttpContext;
  params?:
    | HttpParams
    | Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>>;
  reportProgress?: boolean;
  withCredentials?: boolean;
  credentials?: RequestCredentials;
  keepalive?: boolean;
  priority?: RequestPriority;
  cache?: RequestCache;
  mode?: RequestMode;
  redirect?: RequestRedirect;
  referrer?: string;
  integrity?: string;
  transferCache?: { includeHeaders?: string[] } | boolean;
  timeout?: number;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  getApiAuthMe<TData = UserDto>(
    options?: HttpClientOptions & { observe?: 'body' },
  ): Observable<TData>;
  getApiAuthMe<TData = UserDto>(
    options?: HttpClientOptions & { observe: 'events' },
  ): Observable<HttpEvent<TData>>;
  getApiAuthMe<TData = UserDto>(
    options?: HttpClientOptions & { observe: 'response' },
  ): Observable<AngularHttpResponse<TData>>;
  getApiAuthMe<TData = UserDto>(options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(`/api/auth/me`, options);
  }
}

export type GetApiAuthMeClientResult = NonNullable<UserDto>;
